export default __webpack_public_path__ + "static/media/content_tab04_2_01.55cf0aa7.png";